import { DashboardV2 } from "components/dashboard/DashboardV2";

export const HomePage: React.FC = () => {
    return <DashboardV2 />;
};